/**
 * A count was unlocked only if it is open now and has an unlock on record
 * (an UNLOCK audit event, an unlock time or a reason). Counts that were never
 * locked carry none of these, so "Unlocked by / at / Reason" stays hidden.
 */
export const wasStockTakeUnlocked = stockTake => {
  if (!stockTake || stockTake.isLocked) return false
  const events = Array.isArray(stockTake.lockAuditEvents)
    ? stockTake.lockAuditEvents
    : []
  if (events.some(event => event?.action === 'UNLOCK')) return true
  if (stockTake.unlockedAt) return true
  return Boolean(String(stockTake.unlockReason || '').trim())
}
